import { useEffect, useState } from "react";
import './Slider.css'; // Assuming Slider.css defines the @keyframes for scrollSlider



const Slider = () => {

  const slider1 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_1.jpg";
  const slider2 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_2.jpg";
  const slider3 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_3.jpg";
  const slider4 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_4.jpg";
  const slider5 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_5.jpg";
  const slider6 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_6.jpg";
  const slider7 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_7.jpg";
  const slider8 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_8.jpg";
  const slider9 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_9.jpg";
  const slider10 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_10.jpg";
  const slider11 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_11.jpg";
  const slider12 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_12.jpg";
  const slider13 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_13.jpg";
  const slider14 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_14.jpg";
  const slider15 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_15.jpg";
  const slider16 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_16.jpg";
  const slider17 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_17.jpg";
  const slider18 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_18.jpg";
  const slider19 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_19.jpg";
  const slider20 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_20.jpg";
  const slider21 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_21.jpg";
  const slider22 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_22.jpg";
  const slider23 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_23.jpg";
  const slider24 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_24.jpg";
  const slider25 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_25.jpg";
  const slider26 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_26.jpg";
  const slider27 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_27.jpg";
  const slider28 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_28.jpg";
  const slider29 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_29.jpg";
  const slider30 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_30.jpg";
  const slider31 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_31.jpg";
  const slider32 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/ProjectHighlightSliderSeventhSlide/SITE_32.jpg";


  const images = [
    slider1, slider2, slider3, slider4, slider5, slider6, slider7, slider8,
    slider9, slider10, slider11, slider12, slider13, slider14, slider15, slider16,
    slider17, slider18, slider19, slider20, slider21, slider22, slider23, slider24,
    slider25, slider26, slider27, slider28, slider29, slider30, slider31, slider32
  ];

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartAnimation(true);
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full bg-white py-16">
      <h2 className="text-center text-4xl font-serif text-gray-500 py-4 tracking-wide">
        PROJECT HIGHLIGHTS
      </h2>

      <div className="w-full h-[600px] overflow-hidden relative bg-white">
        {!startAnimation && (
          <img
            src={images[0]}
            alt="Preview"
            className="h-full object-contain transition-opacity duration-500 mx-auto"
          />
        )}

        {startAnimation && (
<div
  className="flex slider-track"
  style={{
    animation: `scrollSlider ${images.length * 1.2}s linear infinite`,
    width: `${images.length * 2 * 450}px`,
  }}
  onTouchStart={(e) => {
    e.currentTarget.style.animationPlayState = "paused";
  }}
  onTouchEnd={(e) => {
    e.currentTarget.style.animationPlayState = "running";
  }}
>
  {[...images, ...images].map((image, index) => (
    <div
      key={index}
      className="flex-shrink-0 h-[600px] w-[450px] flex justify-center items-center"
    >
      <img
        src={image}
        alt={`Slide ${index}`}
        className="h-full w-auto object-contain"
      />
    </div>
  ))}
</div>

        )}
      </div>
    </div>
  );
};

export default Slider;